// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"d0fb497c","326":"ca44b057"}[chunkId] + ".chunk.css";
};